import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PieChartOutlinedSvg from "@ant-design/icons-svg/es/asn/PieChartOutlined";
import AntdIcon from "../components/AntdIcon";
var PieChartOutlined = function PieChartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PieChartOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PieChartOutlined.displayName = 'PieChartOutlined';
}
export default /*#__PURE__*/React.forwardRef(PieChartOutlined);